import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import { CartControls } from "components/common/CartControls";
import { ProductTypeEnum } from "core/enum/product-type.enum";
import { TGetAllStoreProductsData } from "core/models/store-products.model";
import { correctUploadPath } from "core/utils/image-path-correction";
import NoImg from "assets/img/noImage.png";

import Style from "./Style.module.scss";
import { RouteEnum } from "core/enum/route.enum";

interface IProps {
  data: TGetAllStoreProductsData[];
}

const ProductsGrid: FC<IProps> = ({ data }) => {
  return (
    <div className={Style.grid}>
      {data?.map((item) => (
        <ProductCard key={item.id} item={item} />
      ))}
    </div>
  );
};

export { ProductsGrid };

//------------------------------------------------------ Product Card ------------------------------------------------

interface IProductCardProps {
  item: TGetAllStoreProductsData;
}

const typePathMap: Record<ProductTypeEnum, string> = {
  [ProductTypeEnum.PhysicalProduct]: "product",
  [ProductTypeEnum.Service]: "service",
};

const ProductCard: FC<IProductCardProps> = ({ item }) => {
  const history = useHistory();

  const imageSrc =
    item.files && item.files[0]
      ? `${process.env.REACT_APP_UPLOAD_SERVER_PATH}/${correctUploadPath(
          item.files[0],
        )}`
      : NoImg;

  const goToDetails = () => {
    const typePath = typePathMap[item.productTypeEnum] ?? "product";

    // history.push({
    //   pathname: `/store/${typePath}/${item.id}`,
    //   state: {
    //     product: item,
    //   },
    // });

    history.push({
      pathname: RouteEnum.ProductDetails.replace(
        ":type(product|service)",
        typePath,
      ).replace(":id", String(item.id)),
      state: {
        product: item,
      },
    });
  };

  return (
    <div className={Style.card} onClick={goToDetails}>
      <div className={Style.imageWrapper}>
        <img src={imageSrc} alt={item.title} className={Style.image} />
      </div>

      <div className={Style.content}>
        <h3 className={Style.title}>{item.title}</h3>
        <span className={Style.price}>
          {item.price.toLocaleString("fa-IR")} ریال
        </span>
      </div>

      <div className={Style.footer} onClick={(e) => e.stopPropagation()}>
        <CartControls product={item} />
      </div>
    </div>
  );
};

export { ProductCard };
